(function ($, Drupal) {
  Drupal.behaviors.climateScorecard = {
    attach: function (context, settings) {
      // Configuration
      const MAX_TAGS_TO_SHOW = 3;
      const CHAR_LIMIT = 420;

      function getKeyword() {
        const input = document.querySelector(
          '#views-exposed-form-climate-scorecard-climate-scorecard input[name="keyword"]'
        );
        if (input && input.value.trim()) {
          return input.value.trim();
        }
        let keyword = new URLSearchParams(window.location.search).get('keyword');
        if (!keyword && window.location.hash.includes('?')) {
          const hashQuery = window.location.hash.split('?')[1];
          if (hashQuery) {
            keyword = new URLSearchParams(hashQuery).get('keyword');
          }
        }
        return keyword || '';
      }

      function buildSemanticRegex(kw) {
        if (!kw) return null;

        // Ordered longest-first so we strip the longest suffix we can on
        // each pass.
        const suffixes = [
          'mentation', 'isation', 'ization',
          'ments', 'ment', 'ational', 'ation', 'ance', 'ence', 'tional', 'tion', 'sion',
          'ness', 'ible', 'able',
          'ity', 'ive', 'ous', 'ful', 'ial', 'ual',
          'al', 'ly', 'er', 'or', 'ed', 'es', 'en', 'ing', 'ry', 'iz',
          's'
        ];

        // Suffixes that (in real English spelling) are added straight onto
        const suffixesAfterYToI = ['es', 'ed', 'er', 's'];

        // Derive a stem by stripping suffixes repeatedly (not just once),
        let stem = kw.toLowerCase();
        let strippedSomething = true;
        while (strippedSomething) {
          strippedSomething = false;
          let strippedSuffix = null;
          for (let i = 0; i < suffixes.length; i++) {
            if (stem.length > suffixes[i].length + 3 && stem.endsWith(suffixes[i])) {
              stem = stem.slice(0, -suffixes[i].length);
              strippedSuffix = suffixes[i];
              strippedSomething = true;
              break;
            }
          }
          if (stem.length > 4 && /[^aeiou]e$/.test(stem)) {
            stem = stem.slice(0, -1);
            strippedSomething = true;
          } else if (
            strippedSuffix && suffixesAfterYToI.includes(strippedSuffix) &&
            stem.length >= 4 && /[^aeiou]i$/.test(stem)
          ) {
            stem = stem.slice(0, -1) + 'y';
            strippedSomething = true;
          }
        }

        const variants = [stem];
        if (stem.length > 3 && /[^aeiou]y$/.test(stem)) {
          variants.push(stem.slice(0, -1) + 'i');
        }

        const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        // Match the stem (or its spelling variant) plus any trailing word
        // characters so every inflected/derived form highlights.
        const pattern = stem.length >= 4
          ? '\\b(?:' + variants.map(escape).join('|') + ')\\w*'
          : '\\b' + escape(variants[0]) + '\\b';

        return new RegExp(pattern, 'gi');
      }
      const keyword = getKeyword();
      const semanticRegex = buildSemanticRegex(keyword);

      /**
       * Highlight keyword AND its semantic variants inside a table cell.
       * Uses the pre-built semanticRegex so that terms like "governance"
       * get highlighted when the user searched for "government".
       */
      function highlightKeywordInCell(cell, kw) {
        if (!kw || !semanticRegex) return;

        // Reset lastIndex before each use (the regex is global).
        semanticRegex.lastIndex = 0;

        const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT, {
          acceptNode: function (node) {
            return node.parentElement.tagName === 'BUTTON'
              ? NodeFilter.FILTER_REJECT
              : NodeFilter.FILTER_ACCEPT;
          }
        });
        const textNodes = [];
        let n;
        while ((n = walker.nextNode())) textNodes.push(n);
        textNodes.forEach(function (textNode) {
          const text = textNode.textContent;
          semanticRegex.lastIndex = 0;
          if (!semanticRegex.test(text)) { semanticRegex.lastIndex = 0; return; }
          semanticRegex.lastIndex = 0;
          const frag = document.createDocumentFragment();
          let lastIndex = 0;
          let match;
          while ((match = semanticRegex.exec(text)) !== null) {
            if (match.index > lastIndex) {
              frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
            }
            const mark = document.createElement('mark');
            mark.classList.add('keyword-highlight');
            mark.textContent = match[0];
            frag.appendChild(mark);
            lastIndex = match.index + match[0].length;
          }
          if (lastIndex < text.length) {
            frag.appendChild(document.createTextNode(text.slice(lastIndex)));
          }
          textNode.parentNode.replaceChild(frag, textNode);
        });
      }

      const tableRows = context.querySelectorAll("tbody tr");

      tableRows.forEach(function (row) {
        const excerptCell = row.querySelector(".views-field-field-ndc-excerpt");
        const genderCell = row.querySelector(
          ".views-field-field-gender-dimension"
        );

        if (!excerptCell && !genderCell) return;

        // Determine row's initial expanded state
        let isRowExpanded = row.getAttribute("data-row-expanded") === "true";

        // --- Handle NDC Excerpt ---
        if (excerptCell) {
          if (!excerptCell.hasAttribute("data-truncate-processed")) {
            const originalText = excerptCell.textContent.trim();

            if (originalText.length === 0) {
              excerptCell.setAttribute("data-truncate-processed", "true");
              return;
            }

            excerptCell.setAttribute("data-full-text", originalText);

            let truncatedText = originalText;
            let needsTruncation = originalText.length > CHAR_LIMIT;

            if (needsTruncation) {
              let lastSpaceIndex = originalText.lastIndexOf(" ", CHAR_LIMIT);
              truncatedText =
                lastSpaceIndex > 0
                  ? originalText.substring(0, lastSpaceIndex) + "..."
                  : originalText.substring(0, CHAR_LIMIT) + "...";
            }

            excerptCell.setAttribute("data-truncated-text", truncatedText);

            if (needsTruncation) {
              // Auto-expand if any semantic variant of the keyword appears
              // in the hidden (collapsed) portion of the text.
              if (keyword && !isRowExpanded && semanticRegex) {
                const truncationPoint = truncatedText.length - 3; // strip trailing "..."
                const hiddenText = originalText.substring(truncationPoint);
                semanticRegex.lastIndex = 0;
                if (semanticRegex.test(hiddenText)) {
                  isRowExpanded = true;
                  row.setAttribute("data-row-expanded", "true");
                }
              }

              // Create the button element
              const button = document.createElement("button");
              button.type = "button";
              button.classList.add("view-more-button");
              // Set initial text based on row state
              button.textContent = isRowExpanded ? "view less" : "view more";

              // Determine initial text content
              const initialTextContent = isRowExpanded
                ? originalText
                : truncatedText;

              // Clear the cell and append the initial text node and button
              excerptCell.textContent = "";
              excerptCell.appendChild(
                document.createTextNode(initialTextContent)
              );
              excerptCell.appendChild(button);

              // Store the button reference directly on the cell element
              excerptCell._climateScorecardButton = button;

              // Define the click handler
              const buttonClickHandler = function () {
                const isCurrentlyExpanded = excerptCell.getAttribute("data-excerpt-expanded") === "true";
                const fullText = excerptCell.getAttribute("data-full-text");
                const truncatedText = excerptCell.getAttribute(
                  "data-truncated-text"
                );

                let newTextContent, newButtonText, newExpandedState;

                if (isCurrentlyExpanded) {
                  // Currently expanded, need to collapse
                  newTextContent = truncatedText;
                  newButtonText = "view more";
                  newExpandedState = false;
                } else {
                  // Currently truncated, need to expand
                  newTextContent = fullText;
                  newButtonText = "view less";
                  newExpandedState = true;
                }

                // Update Row State
                row.setAttribute("data-row-expanded", newExpandedState);
                excerptCell.setAttribute("data-excerpt-expanded", newExpandedState);

                // Update NDC Excerpt Content and Button
                excerptCell.textContent = "";
                excerptCell.appendChild(
                  document.createTextNode(newTextContent)
                );
                excerptCell.appendChild(button);
                button.textContent = newButtonText;
                highlightKeywordInCell(excerptCell, keyword);

                // --- Synchronize Gender Dimension ---
                const genderCell = row.querySelector(
                  ".views-field-field-gender-dimension"
                );
                if (
                  genderCell &&
                  genderCell.hasAttribute("data-gender-dimension-processed")
                ) {
                  const genderTags = genderCell.querySelectorAll(
                    ".gender-dimension-color"
                  );
                  const needsTagTruncation =
                    genderTags.length > MAX_TAGS_TO_SHOW;
                  const genderButton = genderCell.querySelector(
                    ".view-more-button"
                  );

                  if (needsTagTruncation && genderButton) {
                    // Update tag visibility based on new row state
                    genderTags.forEach((tag, index) => {
                      tag.style.display =
                        index < MAX_TAGS_TO_SHOW || newExpandedState
                          ? "block"
                          : "none";
                    });
                    // Update gender button text based on new row state
                    genderButton.textContent = newExpandedState
                      ? "view less"
                      : "view more";
                  } else if (genderButton && !needsTagTruncation) {
                    // If gender dimension doesn't need truncation, ensure button text reflects row state if button exists
                    genderButton.textContent = newExpandedState
                      ? "view less"
                      : "view more";
                  }
                }
                // --- END Synchronization ---
              };

              // Attach the click handler
              button.addEventListener("click", buttonClickHandler);

              excerptCell.setAttribute("data-excerpt-expanded", isRowExpanded ? "true" : "false");
              excerptCell.setAttribute("data-truncate-processed", "true");
              highlightKeywordInCell(excerptCell, keyword);
            } else {
              // No truncation needed, remove any existing button
              const existingButton = excerptCell.querySelector(
                ".view-more-button"
              );
              if (existingButton) {
                existingButton.remove();
              }
              excerptCell.setAttribute("data-truncate-processed", "true");
              highlightKeywordInCell(excerptCell, keyword);
            }
          } else {
            // Already processed: update state if truncation was needed initially
            const needsTruncation =
              excerptCell.getAttribute("data-full-text") !==
              excerptCell.getAttribute("data-truncated-text");
            if (needsTruncation) {
              const fullText = excerptCell.getAttribute("data-full-text");
              const truncatedText = excerptCell.getAttribute(
                "data-truncated-text"
              );

              const button = excerptCell._climateScorecardButton;
              if (button) {
                excerptCell.textContent = "";
                const textToSet = isRowExpanded ? fullText : truncatedText;
                excerptCell.appendChild(document.createTextNode(textToSet));
                excerptCell.appendChild(button);
                button.textContent = isRowExpanded ? "view less" : "view more";
                excerptCell.setAttribute("data-excerpt-expanded", isRowExpanded ? "true" : "false");
                highlightKeywordInCell(excerptCell, keyword);
              }
            } else {
              const existingButton = excerptCell.querySelector(
                ".view-more-button"
              );
              if (existingButton) {
                existingButton.remove();
              }
              highlightKeywordInCell(excerptCell, keyword);
            }
          }
        }

        // --- Handle Gender Dimension Tags ---
        if (genderCell) {
          if (!genderCell.hasAttribute("data-gender-dimension-processed")) {
            const tags = genderCell.querySelectorAll(".gender-dimension-color");
            const totalTags = tags.length;
            const needsTagTruncation = totalTags > MAX_TAGS_TO_SHOW;

            if (needsTagTruncation) {
              tags.forEach((tag, index) => {
                tag.style.display =
                  index < MAX_TAGS_TO_SHOW || isRowExpanded ? "block" : "none";
              });

              const button = document.createElement("button");
              button.type = "button";
              button.classList.add("view-more-button");
              button.textContent = isRowExpanded ? "view less" : "view more";
              genderCell.appendChild(button);

              // Gender Button Click Handler (ALSO INCLUDES NDC SYNC)
              button.addEventListener("click", function () {
                const currentExpanded =
                  row.getAttribute("data-row-expanded") === "true";
                const newExpanded = !currentExpanded;
                row.setAttribute("data-row-expanded", newExpanded);

                // Update NDC excerpt state
                const ndcCell = row.querySelector(
                  ".views-field-field-ndc-excerpt"
                );
                if (
                  ndcCell &&
                  ndcCell.hasAttribute("data-truncate-processed")
                ) {
                  const needsNdcTruncation =
                    ndcCell.getAttribute("data-full-text") !==
                    ndcCell.getAttribute("data-truncated-text");
                  if (needsNdcTruncation) {
                    const fullText = ndcCell.getAttribute("data-full-text");
                    const truncatedText = ndcCell.getAttribute(
                      "data-truncated-text"
                    );
                    const ndcButton = ndcCell._climateScorecardButton;

                    if (ndcButton) {
                      ndcCell.textContent = "";
                      const ndcTextToSet = newExpanded
                        ? fullText
                        : truncatedText;
                      ndcCell.appendChild(
                        document.createTextNode(ndcTextToSet)
                      );
                      ndcCell.appendChild(ndcButton);
                      ndcButton.textContent = newExpanded
                        ? "view less"
                        : "view more";
                      ndcCell.setAttribute("data-excerpt-expanded", newExpanded ? "true" : "false");
                      highlightKeywordInCell(ndcCell, keyword);
                    }
                  }
                }

                // Update Gender tags state
                tags.forEach((tag, index) => {
                  tag.style.display =
                    index < MAX_TAGS_TO_SHOW || newExpanded ? "block" : "none";
                });
                button.textContent = newExpanded ? "view less" : "view more";
              });
            }
            genderCell.setAttribute("data-gender-dimension-processed", "true");
          }
        }
      });

      // Color adjustment for gender tags
      function isLightColor(rgbString) {
        const match = rgbString.match(
          /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/
        );
        if (!match) {
          console.warn("Could not parse RGB/RGBA string:", rgbString);
          return true;
        }
        const r = parseInt(match[1], 10);
        const g = parseInt(match[2], 10);
        const b = parseInt(match[3], 10);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.5;
      }

      function adjustTextColor(element) {
        const bgColor = element.style.backgroundColor;
        if (bgColor) {
          if (isLightColor(bgColor)) element.style.color = "black";
          else element.style.color = "white";
        } else {
          console.warn(
            "No 'background-color' found in the 'style' attribute for element:",
            element
          );
        }
      }

      context
        .querySelectorAll(".gender-dimension-color")
        .forEach(adjustTextColor);

      // CLEAR SEARCH INPUT WHEN RESET CLICKED

      const resetButton = context.querySelector('.facets-reset-link');

      if (resetButton) {
        resetButton.addEventListener('click', function (e) {
          const searchInput = context.querySelector(
            '#views-exposed-form-climate-scorecard-climate-scorecard input[name="keyword"]'
          );

          if (searchInput) {
            searchInput.value = '';
          }
          window.location.href = this.href;
          window.location.reload();
        });
      }

      // FILTERS SUMMARY - TOGGLE ALL FILTERS
      this.initializeFacetSummaryToggle(context);
    },

    // FILTERS SUMMARY - TOGGLE ALL FILTERS
    initializeFacetSummaryToggle: function (context) {
      // Debounce function to prevent multiple rapid calls
      let debounceTimer;

      // Function to handle facet summary toggle logic
      const setupFacetToggle = () => {
        const facetSummary = context.querySelector(
          ".climate-scorecard-summary .block-facets-summary"
        );

        if (!facetSummary) return;

        // Find the toggle link
        const toggleLink = facetSummary.querySelector(
          ".show-all-filters-toggle"
        );
        if (!toggleLink) return; // If not in template, skip

        const list = facetSummary.querySelector(".facet-summary-item-list");
        if (!list) return;

        // Function to check if content overflows 2 lines
        function isOverflowing() {
          // Ensure the list is visible before measuring
          const originalDisplay = list.style.display;
          const originalMaxHeight = list.style.maxHeight;
          const originalVisibility = list.style.visibility;

          // Temporarily make sure it's visible for measurement
          list.style.display = "flex";
          list.style.maxHeight = "none";
          list.style.visibility = "hidden"; // Make invisible but still measurable

          // Force a reflow to ensure styles are applied
          list.offsetHeight;

          const fullHeight = list.scrollHeight;

          // Restore original styles
          list.style.maxHeight = originalMaxHeight;
          list.style.display = originalDisplay;
          list.style.visibility = originalVisibility;

          return fullHeight > 104; // 2-line height
        }

        // Function to update toggle visibility and text
        function updateToggle() {
          // Add a small delay to ensure DOM is stable
          setTimeout(() => {
            if (isOverflowing()) {
              toggleLink.style.display = "inline-block";
              // Update text based on current state
              const currentState = toggleLink.getAttribute("data-state");
              toggleLink.textContent =
                currentState === "expanded"
                  ? "Hide all filters"
                  : "Show all filters";
            } else {
              toggleLink.style.display = "none";
            }
          }, 10);
        }

        // Initial update
        updateToggle();

        // Toggle handler
        toggleLink.removeEventListener("click", toggleLink._clickHandler); // Remove any existing handler
        const clickHandler = function () {
          const currentState = this.getAttribute("data-state");
          if (currentState === "collapsed") {
            list.style.maxHeight = "none";
            this.setAttribute("data-state", "expanded");
          } else {
            list.style.maxHeight = "104px";
            this.setAttribute("data-state", "collapsed");
          }

          // Update text immediately after toggle
          updateToggle();
        };

        toggleLink._clickHandler = clickHandler;
        toggleLink.addEventListener("click", clickHandler);

        // Re-check on window resize
        window.removeEventListener("resize", updateToggle); // Remove any existing listener
        window.addEventListener("resize", updateToggle);
      };

      // Initial setup
      setupFacetToggle();

      // Listen for Drupal AJAX events and re-run setup
      $(document).ajaxStop(function () {
        // Clear any existing debounce timer
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
          setupFacetToggle();
        }, 150);
      });
    }
  };
})(jQuery, Drupal);
